import {SubTitle} from "./styled";

export const SectionSubTitle = ({children}) => {
    return (
        <SubTitle>
            {children}
        </SubTitle>
    )
}